import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useRef } from 'react';
import { Card, Typography, Spin } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import keycloakService from '../services/KeycloakService';
const { Text } = Typography;
/**
 * LoginPage — redirige automáticamente a Keycloak al montarse.
 * No muestra ningún botón intermedio: si el usuario no está autenticado,
 * se inicia el flujo de login de Keycloak de forma inmediata.
 */
const LoginPage = () => {
    const navigate = useNavigate();
    const { isAuthenticated, isLoading } = useAuth();
    const loginTriggered = useRef(false);
    // Si ya está autenticado, redirigir al dashboard
    useEffect(() => {
        if (isAuthenticated && !isLoading) {
            navigate('/dashboard', { replace: true });
        }
    }, [isAuthenticated, isLoading, navigate]);
    // Si no está autenticado y terminó de cargar, redirigir a Keycloak
    useEffect(() => {
        if (!isLoading && !isAuthenticated && !loginTriggered.current) {
            loginTriggered.current = true;
            keycloakService.login();
        }
    }, [isLoading, isAuthenticated]);
    return (_jsx("div", { style: {
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'linear-gradient(135deg, var(--ant-color-primary) 0%, var(--color-selected) 100%)',
        }, children: _jsxs(Card, { style: { textAlign: 'center', padding: '40px' }, children: [_jsx(Spin, { size: "large" }), _jsx("div", { style: { marginTop: 16 }, children: _jsx(Text, { children: "Redirigiendo a Keycloak..." }) })] }) }));
};
export default LoginPage;
